<ng-container *ngIf="mode$ | async as mode">
    <button
        *ngIf="mode !== 'hidden'"
        type="button"
        class="pwa-install-button"
        [ngClass]="'pwa-install-button--' + appearance"
        [disabled]="isProcessing"
        [attr.aria-busy]="isProcessing"
        (click)="install(mode)"
    >
        <mat-icon
            class="pwa-install-button__icon"
            svgIcon="download"
        ></mat-icon>
        <span>Установить приложение</span>
    </button>
</ng-container>
